<template>
  <div class="content_main">
    <div class="content_main_top">
      <a-input placeholder="请输入字典名称" class="a_input_self margin_self" v-model="queryParam.dictName" @keyup.enter.native="$refs.table.refresh(true)" />
      <a-input placeholder="请输入字典类型" class="a_input_self margin_self" v-model="queryParam.dictType" @keyup.enter.native="$refs.table.refresh(true)" />
      <a-select placeholder="请选择状态" class="a_input_self margin_self" v-model="queryParam.status" default-value="0" @keyup.enter.native="$refs.table.refresh(true)">
        <a-select-option :value="''">全部</a-select-option>
        <a-select-option :value="0">正常</a-select-option>
        <a-select-option :value="1">禁用</a-select-option>
      </a-select>
      <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
      <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
      <a-button v-if="addEnable" type="primary" icon="plus" @click="$refs.modal.add()">新建</a-button>
      <a-dropdown v-if="removeEnable && selectedRowKeys.length > 0">
        <a-button type="danger" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button>
      </a-dropdown>
    </div>
    <div class="content_main_center_scroll" id="content_main_center_scroll">
      <s-table
        size="default"
        ref="table"
        rowKey="dictId"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :columns="columns"
        :data="loadData"
        defaultSort="createTime"
        :scroll="{ y: scroll_y }"
      >
        <span slot="status" slot-scope="text">
          <a-badge :status="text | statusTypeFilter" :text="text | statusFilter" />
        </span>
        <span slot="action" slot-scope="text, record">
          <a v-if="editEnabel" @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a v-if="editEnabel" @click="dataModal(record.dictType)"><a-icon type="bars" />列表</a>
          <a-divider type="vertical" />
          <a v-if="removeEnable" @click="delByIds([record.dictId])">删除</a>
        </span>
      </s-table>
    </div>

    <dict-modal ref="modal" @ok="handleOk" />
    <dict-data-list-modal ref="datamodal" @ok="handleOk" />
  </div>
</template>

<script>
import { STable } from '@/components'
import { getDictTypeList, delDictType } from '@/api/system'
import DictModal from './modules/DictModal.vue'
import DictDataListModal from './modules/DictDataListModal.vue'
import { checkPermission } from '@/utils/permissions'

const statusMap = {
  0: {
    status: 'success',
    text: '正常',
  },
  1: {
    status: 'default',
    text: '停用',
  },
}

export default {
  name: 'TableList',
  components: {
    STable,
    DictModal,
    DictDataListModal,
  },
  data() {
    return {
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      form: this.$form.createForm(this),
      mdl: {},
      permissions: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '字典主键',
          dataIndex: 'dictId',
        },
        {
          title: '字典名称',
          dataIndex: 'dictName',
        },
        {
          title: '字典类型',
          dataIndex: 'dictType',
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '备注',
          dataIndex: 'remark',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          sorter: true,
        },
        {
          title: '操作',
          width: '200px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return getDictTypeList(Object.assign(parameter, this.queryParam))
      },
      selectedRowKeys: [],
      selectedRows: [],
      addEnable: checkPermission('system:dict:add'),
      editEnabel: checkPermission('system:dict:edit'),
      removeEnable: checkPermission('system:dict:remove'),
    }
  },
  filters: {
    statusFilter(type) {
      return statusMap[type].text
    },
    statusTypeFilter(type) {
      return statusMap[type].status
    },
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height() - 50
        this.$forceUpdate()
      }, 1000)
    })
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    handleAdd(parentId) {
      this.$refs.modal.add(parentId)
    },
    handleEdit(record) {
      this.$refs.modal.edit(record)
    },
    handleOk() {
      this.$refs.table.refresh(true)
      console.log('handleSaveOk')
    },
    dataModal(dictType) {
      this.$refs.datamodal.show(dictType)
    },
    delByIds(ids) {
      delDictType({ ids: ids.join(',') }).then((res) => {
        if (res.code === 200) {
          this.$message.success(`删除成功`)
          this.handleOk()
        } else {
          this.$message.error(res.msg)
        }
        this.selectedRowKeys = []
      })
    },
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  },
}
</script>
